import styled from "styled-components";

export const ButtonsRow = styled.div`
  width: 100%;
  display: flex;
  gap: 16px;

  & button {
    flex: 1 1 0;
    height: 67px;
    margin-right: 0;
    font-size: 16px;
    border-radius: 5px;
  }
`;
